<template>
<v-card flat>
  <v-card-title class='py-1 overline grey darken-4 text white--text' >
    Please confirm:
    <v-spacer />
    <!-- <v-btn @click='$emit("fullscreen")' ></v-btn> -->
    <v-btn dark icon @click='$emit("close")' small ><v-icon small>close</v-icon></v-btn>
  </v-card-title>
  <v-list dark three-line >
    <v-list-tile v-if='appointment' >
      <v-list-tile-avatar v-if='profilePicture' >
        <v-img :src='profilePicture' />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if='appointment.title' v-text='appointment.title' />
        <v-list-tile-title v-if='relationship' >
          {{ formatFullName(relationship) }}
          <small v-if='practitioner' >with {{ formatFullName(practitioner) }}</small>
        </v-list-tile-title>
        <v-list-tile-sub-title >
          <template v-if='appointment.product' >{{appointment.product.title}}</template>
          <template v-if='appointment.service' >@ {{appointment.service.title}}</template>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title >
          <strong>{{ dateformat(appointment.day) }}.</strong>
          {{appointment.start_time}} - {{appointment.end_time}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

  <v-list three-line class='pa-0' >
    <v-list-tile
        v-show='relationship && relationship.id'
        @click='confirmOptions.create_process = !confirmOptions.create_process' >
        <v-list-tile-avatar >
          <v-checkbox
            @click.prevent=''
            :disabled='!hasContacts'
            v-model='confirmOptions.create_process' ></v-checkbox>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            Send notifications
          </v-list-tile-title>
          <!-- <v-list-tile-sub-title class='yellow' v-if='appointment.client && appointment.client.id && !appointment.client.phone_number' >
            Client has no phone number. We won't be able to send SMSes
          </v-list-tile-sub-title> -->
          <!-- <v-list-tile-sub-title class='yellow' v-if='appointment.client && appointment.client.id && !isRealEmail(appointment.client.email)' >
            No valid email address. We won't be able to send emails
          </v-list-tile-sub-title> -->
          <v-list-tile-sub-title>
            Send confirmation and reminders to
            <span v-if='appointment.client' > {{ formatFullName(relationship) }}</span>
            <span v-else >client</span>
          </v-list-tile-sub-title>
          <v-list-tile-sub-title>
            <template v-if='!hasContacts' >
                <v-chip
                outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning'>
                <v-icon small >warning</v-icon>
                No contact info
              </v-chip>
            </template>
            <template v-else>
              <v-chip outline outlined label
                v-if='clientPhoneNumber'
                @click.stop='editClient' color='primary' class='v-chip--x-small' >
                {{clientPhoneNumber}}
                <!-- <v-icon small right outlined >phone</v-icon> -->
              </v-chip>
              <v-chip v-else outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning' >
                <v-icon small >warning</v-icon>
                No phone no.
              </v-chip>

              <v-chip outline outlined label
                v-if='clientEmail'
                @click.stop='editClient'
                color='primary' class='v-chip--x-small' >
                {{ clientEmail }}
                <!-- <v-icon small right >send</v-icon> -->
              </v-chip>
              <v-chip v-else outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning' >
                <v-icon small >warning</v-icon>
                No email
              </v-chip>
            </template>
          </v-list-tile-sub-title>
          <v-list-tile-sub-title v-if='isInPast && confirmOptions.create_process' class='amber px-2 caption' >
            <v-icon small >warning</v-icon> Note, you've opted to send notifications, but this appointment is in the past. Are you sure?
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-btn @click='editClient' icon ><v-icon>edit</v-icon></v-btn>
        </v-list-tile-action>
        <v-list-tile-action >
          <v-icon v-if='confirmOptions.create_process' >notifications_on</v-icon>
          <v-icon v-else >notifications_off</v-icon>
        </v-list-tile-action>
      </v-list-tile>
        <!-- <pre>SC: {{relationshipId}} / {{storeClient}}</pre> -->

      <!-- recurring -->
      <v-list-tile >
        <v-list-tile-avatar >
          <v-checkbox v-model='confirmOptions.recurring' ></v-checkbox>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            Make this appointment repeat
          </v-list-tile-title>
          <v-list-tile-sub-title>
            Check to configure how this appointment should recur
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

        <!-- recurring frequency -->
      <v-list-tile v-if='confirmOptions.recurring' >
        <!-- <v-list-tile-avatar >
          <v-icon >replay</v-icon>
        </v-list-tile-avatar> -->
        <v-list-tile-content class='ml-3' >
          <v-list-tile-title style='height:32px;'>
            Repeat
            <v-btn @click='confirmOptions.recurrance.count--' small icon><v-icon>remove_circle</v-icon></v-btn>
            {{confirmOptions.recurrance.count}}
            <v-btn @click='confirmOptions.recurrance.count++' small icon><v-icon>add_circle</v-icon></v-btn>
            times
          </v-list-tile-title>
          <!-- <v-list-tile-sub-title >
            <v-btn @click='recurringTest'
            :disabled='recurringVerifyRequestStatus === 0'
            flat small >Verify</v-btn>
            <div v-if='recurringVerifyRequestStatus === 200' >
              last appointment will be
              {{dateformat(recurringVerifyRequest.result.data.recurrance[recurringVerifyRequest.result.data.recurrance.length-1][0], 'ddd DD MMM')}}
            </div>
          </v-list-tile-sub-title> -->
          <!-- <vuex-loader :request-id='reqClashCheckId' ></vuex-loader> -->
        </v-list-tile-content>
        <v-list-tile-action >
          <v-dialog v-model="recurranceIntervalPicker" lazy >
            <v-btn slot='activator' class='mt-2' small >
              <v-icon>expand_more</v-icon>
              {{confirmOptions.recurrance.interval}}
            </v-btn>
            <v-list subheader>
              <v-subheader>Choose an interval rate</v-subheader>
              <v-list-tile
                @click='confirmOptions.recurrance.interval = item; recurranceIntervalPicker = false'
                v-for='item in recurranceItems' :key='item' >
                <v-list-tile-content>
                  <v-list-tile-title>{{item}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-dialog>
        </v-list-tile-action>
      </v-list-tile>

      <v-list-tile >
        <v-list-tile-content>
            <v-list-tile-sub-title v-if='confirmOptions.recurring'>
              <v-icon small >info</v-icon>
              This will create {{confirmOptions.recurrance.count}} appointments
            </v-list-tile-sub-title>

            <v-list-tile-sub-title>
              <template v-if='confirmOptions.create_process' >
                <v-icon small >notifications_on</v-icon>
                We will send a confirmation to the client now, and a reminder one day before the appointment
              </template>
              <span v-else >
                <v-icon small >notifications_off</v-icon> No notifications will be sent
              </span>
            </v-list-tile-sub-title>

        </v-list-tile-content>
      </v-list-tile>
  </v-list>
  <v-card-actions >
    <v-btn block large
      :loading='loading' color='primary' class='mb-3'
      @click='$emit("confirm", confirmOptions)' >Create</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import AppointmentListItem from '@/components/appointment/AppointmentListItem.vue'
import {DateTime} from 'luxon'

export default {
  name: 'ConfirmAppointment',
  components: {AppointmentListItem},
  props: {
    appointment: { type: Object, required: true },
    practitioner: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      recurranceIntervalPicker: false,
      recurranceItems: [
        'Daily',
        'Weekly',
        'Monthly',
        'Yearly'
      ],
      confirmOptions: {
        create_process: false,
        recurring: false,
        recurrance: {
          count: 1,
          interval: 'Weekly'
        }
      }
    }
  },
  watch: {
    hasContacts () {
      if (!this.hasContacts) {
        this.confirmOptions.create_process = false
      }
    }
  },
  methods: {
    editClient () {
      if (this.relationshipId) {
        this.launchCustomerDetailsDialog(this.relationshipId, true)
      }
    }
  },
  computed: {
    isInPast () {
      let startTime = DateTime.local()
      let now = DateTime.local()
      if (this.appointment && this.appointment.start_time) {
        let startDateTime = this.appointment.day + 'T' + this.appointment.start_time
        startTime = DateTime.fromISO(startDateTime)
      }
      return startTime <= now
    },
    profilePicture () {
      return this.getProfilePicture(this.practitioner)
    },
    relationship () {
      return this.getObjectPath(this.appointment, 'relationship')
    },
    relationshipId () {
      if (this.relationship) {
        return this.relationship.id
      }
      return null
    },
    clientPhoneNumber () {
      return this.getObjectPath(this.relationship, 'client.phone_number', null)
    },
    clientEmail () {
      // client.client && client.client.id && !isRealEmail(client.client.email)
      let email = this.getObjectPath(this.relationship, 'client.email', null)
      if (this.isRealEmail(email)) { return email }
      return null
    },
    hasContacts () {
      if (this.clientPhoneNumber || this.clientEmail) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Confirm.vue?1e5ac258